import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import './utils/flutter-bridge'
import { getMobileApiUrl } from './config/environment'

// Import configuration service
import configService from './services/configService'

// Import SignalR plugin
import SignalRPlugin from './plugins/signalR'

// Configure dayjs with relativeTime plugin (only plugin needed)
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

// Expose API base URL globally for Flutter bridge
window.AKAT_API_BASE_URL = getMobileApiUrl()

// Add global CSS fixes for welcome page
const globalStyles = `
  body {
    margin: 0 !important;
    padding: 0 !important;
    background: transparent !important;
    overflow-x: hidden !important;
  }
  
  html {
    margin: 0 !important;
    padding: 0 !important;
    background: transparent !important;
  }
  
  #app {
    background: transparent !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  
  .welcome-page {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%) !important;
  }
  
  /* Override any loading screen styles */
  .loading {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%) !important;
  }
  
  /* Ensure welcome page takes full height */
  .welcome-page,
  .welcome-page * {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%) !important;
  }
  
  /* Override any Element Plus or other framework styles */
  .el-main,
  .el-container,
  .main-content {
    background: transparent !important;
  }
  
  /* Force welcome page background */
  .welcome-layout,
  .welcome-layout * {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%) !important;
  }

  /* MODERN BUTTON STYLES - Clean and Simple */
  .el-button {
    border-radius: 8px !important;
    border: 1px solid transparent !important;
    box-shadow: none !important;
    font-weight: 500 !important;
    transition: all 0.2s ease !important;
    padding: 10px 20px !important;
    min-height: 40px !important;
  }

  .el-button:hover {
    transform: translateY(-1px) !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  }

  .el-button:active {
    transform: translateY(0) !important;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1) !important;
  }

  /* Primary button - Clean blue */
  .el-button--primary {
    background: #3b82f6 !important;
    color: white !important;
    border-color: #3b82f6 !important;
  }

  .el-button--primary:hover {
    background: #2563eb !important;
    border-color: #2563eb !important;
  }

  /* Success button - Clean green */
  .el-button--success {
    background: #10b981 !important;
    color: white !important;
    border-color: #10b981 !important;
  }

  .el-button--success:hover {
    background: #059669 !important;
    border-color: #059669 !important;
  }

  /* Danger button - Clean red */
  .el-button--danger {
    background: #ef4444 !important;
    color: white !important;
    border-color: #ef4444 !important;
  }

  .el-button--danger:hover {
    background: #dc2626 !important;
    border-color: #dc2626 !important;
  }

  /* Warning button - Clean orange */
  .el-button--warning {
    background: #f59e0b !important;
    color: white !important;
    border-color: #f59e0b !important;
  }

  .el-button--warning:hover {
    background: #d97706 !important;
    border-color: #d97706 !important;
  }

  /* Info button - Clean gray */
  .el-button--info {
    background: #6b7280 !important;
    color: white !important;
    border-color: #6b7280 !important;
  }

  .el-button--info:hover {
    background: #4b5563 !important;
    border-color: #4b5563 !important;
  }

  /* Default button - Clean white */
  .el-button {
    background: white !important;
    color: #374151 !important;
    border-color: #d1d5db !important;
  }

  .el-button:hover {
    background: #f9fafb !important;
    border-color: #9ca3af !important;
    color: #111827 !important;
  }

  /* Plain buttons - Clean transparent */
  .el-button.is-plain {
    background: transparent !important;
    border-color: #d1d5db !important;
    color: #374151 !important;
  }

  .el-button.is-plain:hover {
    background: #f9fafb !important;
    border-color: #9ca3af !important;
    color: #111827 !important;
  }

  /* Text buttons - Clean minimal */
  .el-button.is-text {
    background: transparent !important;
    border-color: transparent !important;
    color: #3b82f6 !important;
    padding: 8px 16px !important;
  }

  .el-button.is-text:hover {
    background: #eff6ff !important;
    color: #2563eb !important;
  }

  /* Disabled state */
  .el-button.is-disabled,
  .el-button.is-disabled:hover {
    background: #f3f4f6 !important;
    color: #9ca3af !important;
    border-color: #e5e7eb !important;
    cursor: not-allowed !important;
    transform: none !important;
    box-shadow: none !important;
  }

  /* Small buttons */
  .el-button--small {
    padding: 6px 12px !important;
    font-size: 12px !important;
    min-height: 32px !important;
  }

  /* Large buttons */
  .el-button--large {
    padding: 12px 24px !important;
    font-size: 16px !important;
    min-height: 48px !important;
  }

  /* Round buttons */
  .el-button.is-round {
    border-radius: 20px !important;
  }

  /* Circle buttons */
  .el-button.is-circle {
    border-radius: 50% !important;
    padding: 10px !important;
    min-width: 40px !important;
    min-height: 40px !important;
  }

  /* Override any existing button styles in components */
  .btn {
    border-radius: 8px !important;
    border: 1px solid transparent !important;
    box-shadow: none !important;
    font-weight: 500 !important;
    transition: all 0.2s ease !important;
    padding: 10px 20px !important;
    min-height: 40px !important;
  }

  .btn:hover {
    transform: translateY(-1px) !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  }

  .btn-primary {
    background: #3b82f6 !important;
    color: white !important;
    border-color: #3b82f6 !important;
  }

  .btn-primary:hover {
    background: #2563eb !important;
    border-color: #2563eb !important;
  }

  .btn-secondary {
    background: #6b7280 !important;
    color: white !important;
    border-color: #6b7280 !important;
  }

  .btn-secondary:hover {
    background: #4b5563 !important;
    border-color: #4b5563 !important;
  }

  .btn-success {
    background: #10b981 !important;
    color: white !important;
    border-color: #10b981 !important;
  }

  .btn-success:hover {
    background: #059669 !important;
    border-color: #059669 !important;
  }

  .btn-danger {
    background: #ef4444 !important;
    color: white !important;
    border-color: #ef4444 !important;
  }

  .btn-danger:hover {
    background: #dc2626 !important;
    border-color: #dc2626 !important;
  }

  .btn-warning {
    background: #f59e0b !important;
    color: white !important;
    border-color: #f59e0b !important;
  }

  .btn-warning:hover {
    background: #d97706 !important;
    border-color: #d97706 !important;
  }
`

// Inject global styles
const styleElement = document.createElement('style')
styleElement.textContent = globalStyles
document.head.appendChild(styleElement)

const app = createApp(App)

// Register Element Plus icons
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// Make config service available globally
app.config.globalProperties.$config = configService

app.use(store)
app.use(router)
app.use(ElementPlus)

// Use SignalR plugin with auto-connect disabled for faster initial load
app.use(SignalRPlugin, {
  autoConnect: false // Disable auto-connect to speed up initial load
})

// Optimized initialization sequence
const initializeApp = async () => {
  try {
    console.log('🚀 Starting optimized app initialization...')
    
    // 1. Initialize Flutter bridge first (fast, local operation)
    await store.dispatch('initFlutterBridge')
    console.log('✅ Flutter bridge initialized')
    
    // 2. Initialize language store with caching optimization
    const languagePromise = store.dispatch('language/initialize')
    
    // 3. Check auth status in parallel
    const authPromise = store.dispatch('auth/checkAuthStatus')
    
    // 4. Wait for both to complete
    await Promise.all([languagePromise, authPromise])
    console.log('✅ Language and auth initialized')
    
    // 5. Connect SignalR only after core initialization
    if (store.getters['auth/isAuthenticated']) {
      // Initialize SignalR connection for authenticated users
      store.dispatch('signalR/connect')
      console.log('✅ SignalR connected')
    }
    
    console.log('✅ App initialization completed successfully')
    console.log('🌐 Environment:', configService.getEnvironmentInfo())
    
  } catch (error) {
    console.error('❌ App initialization failed:', error)
    // Continue app loading even if some services fail
  }
}

// Start initialization after app is mounted
app.mount('#app')

// Register service worker for caching
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('✅ Service Worker registered successfully:', registration)
      })
      .catch(error => {
        console.log('❌ Service Worker registration failed:', error)
      })
  })
}

// Initialize app asynchronously after mount
initializeApp() 